import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_PIPELINE_ENTITIES_ACTION_TYPE } from '../actions';

const initialState = {
  data: {},
  metadata: {},
  partialLoadedEntriesIds: {},
  summaryData: {},
};

const loanPipelineEntitiesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.GET_PIPELINE_ENTITIES_DATA: {
        const data = payload || initialState.data;
        draft.data = meta.isFirstFetch ? data : { ...draft.data, ...data };
        draft.metadata = meta || initialState.metadata;
        break;
      }

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.UPDATE_PIPELINE_ENTITY_DATA:
        draft.data[payload.entityId] = { ...draft.data[payload.entityId], ...payload };
        break;

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.UPDATE_PIPELINE_ENTITY_DATA_V2:
        draft.data[payload.entryId] = { ...draft.data[payload.entryId], ...payload };
        break;

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.OVERRIDE_PIPELINE_ENTITY_DATA:
        draft.data[payload.entityId] = { ...draft.data[meta.entityId], ...payload };
        break;

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.UPDATE_PARTIAL_LOADED_ENTITY_IDS:
        payload.forEach(entryId => {
          if (meta.isDeleted) {
            delete draft.partialLoadedEntriesIds[entryId];

            return;
          }

          draft.partialLoadedEntriesIds[entryId] = true;
        });
        break;

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.DELETE_PIPELINE_ENTITIES_DATA:
        payload.forEach(entityId => delete draft.data[entityId]);
        break;

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.SET_BASIC_SUMMARY_DATA: {
        const entity = draft.data[payload.applicationId];

        draft.summaryData.applicationId = payload.applicationId;
        draft.summaryData.loanId = entity?.loanId || payload.loanId;
        draft.summaryData.summary = entity?.summary;
        break;
      }

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.GET_AUS_FINDINGS_DATA: {
        draft.summaryData.ausFindings = payload;
        break;
      }

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.GET_LOAN_SUMMARY_TASK_DATA: {
        draft.summaryData.tasks = payload;
        break;
      }

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.GET_LOAN_SUMMARY_CONDITIONS_DATA: {
        draft.summaryData.conditions = payload;
        break;
      }

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.GET_LOAN_SUMMARY_CONTACTS_DATA: {
        draft.summaryData.contacts = payload;
        break;
      }

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.GET_LOAN_SUMMARY_PROGRESS_DATA: {
        draft.summaryData.progress = payload;
        break;
      }

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.RESET_SUMMARY_DATA:
        draft.summaryData = {};
        break;

      case LOAN_PIPELINE_ENTITIES_ACTION_TYPE.RESET_PIPELINE_ENTITIES_DATA:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanPipelineEntitiesReducer;
